import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils';

type ProductDraftsCountErrorProps = {
    /** Reads the count again. */
    onRetry: () => void;
};

const COPY = 'products.components.productTable.drafts';

/**
 * The draft count could not be read (rulebook §12): a danger notice with
 * Try again, in the drafts notice's place. The list below keeps working.
 */
export const ProductDraftsCountError: React.FC<
    ProductDraftsCountErrorProps
> = ({ onRetry }) => {
    const { t } = useTranslation('pages');

    return (
        <Alert
            role="alert"
            status="danger"
            {...getNodeTestIdProp('products-drafts-count-error')}
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>{t(`${COPY}.errorTitle`)}</Alert.Title>
                <Alert.Description>
                    {t(`${COPY}.errorMessage`)}
                </Alert.Description>
            </Alert.Content>
            <Button
                onPress={onRetry}
                size="sm"
                variant="secondary"
                {...getNodeTestIdProp('products-drafts-count-retry')}
            >
                {t(`${COPY}.retry`)}
            </Button>
        </Alert>
    );
};
